import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';

class NumberAtaAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterNumbers(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterNumbers = value => {
    const inputValue = value.trim().toLowerCase();
    const { numbers, showUnassigned } = this.props;
    return numbers.filter(item => {
      const notAssigned = !(
        item?.linkedBox ||
        (showUnassigned && item.type !== 'unassigned') ||
        (!showUnassigned && (item.type === 'vmail' || item.type === 'forward'))
      )
      return notAssigned && item.number.toLowerCase().includes(inputValue);
    });
  };

  getNumberValue = item => item.number || '';

  renderSuggestion = item => {
    const { showUnassigned } = this.props;

    {/* item?.linkedBox is a replacement of linkedToObi */}
    if (
      item.linkedToExternalAta ||
      (item?.linkedBox) ||
      (showUnassigned && item.type !== 'unassigned') ||
      (!showUnassigned && (item.type === 'vmail' || item.type === 'forward'))
    ) {
      return <div className="disabled-suggestion">{item.number || ''}</div>;
    }
    return <div>{item.number || ''}</div>;
  };

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'number', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterNumbers(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onNumberSelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'number', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { numbers, userAutocomplete } = this.props;
      const suggestion = !userAutocomplete
        ? numbers.filter(item => item.number === e.currentTarget.value)
        : numbers.filter(item => item.number === e.currentTarget.value);
      this.props.onChange({
        name: 'number',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Number...',
      disabled: this.props.isDisabled || false,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'number',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getNumberValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onNumberSelected}
        />
      </div>
    );
  }
}

export default NumberAtaAutocomplete;
